import { h } from 'preact'
import TopicModeration from '../../topic-moderation'
import { Topic } from '../../topic-moderation/interfaces'

const ProductUpdateModeration = ({ topic, topicType, phrases } : { topic: Topic, topicType: 'productUpdate', phrases: {[key:string]: string} }) =>
  <TopicModeration topic={topic} topicType={topicType} phrases={phrases} />

export default ProductUpdateModeration
